var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "box" },
    [
      _c("ApexChart", {
        attrs: {
          width: "99%",
          height: "265",
          type: "bar",
          options: _vm.chartOptions,
          series: _vm.salesItemsSeries
        }
      }),
      _c("BLoading", {
        attrs: { active: _vm.loading, "is-full-page": false },
        on: {
          "update:active": function($event) {
            _vm.loading = $event
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }